import MSDKV3Adapter from './v3';
import MSDKV5Adapter from './v5';
import NonAdapter from './non';

function getMSDKVersion() {
  const regMSDKV3 = /[?&]msdkEncodeParam=/;
  const regMSDKV5 = /[?&]itopencodeparam=/;
  const search = location.search;
  if (regMSDKV3.test(search)) return 'v3';
  if (regMSDKV5.test(search)) return 'v5';
  return 'non';
}

export function getAdapter() {
  const version = getMSDKVersion();
  switch (version) {
    case 'non':
      return new NonAdapter();
    case 'v5':
      return new MSDKV5Adapter();
    case 'v3':
      return new MSDKV3Adapter();
  }
}
